import React from 'react'

export default function Pricing() {
    return (
        <div class="bg-blue-100 flex items-center justify-center p-6">
            <div class="max-w-5xl w-full flex flex-col items-center justify-center">
                <div className="mt-2 justify-center">
                    <a href="https://play.google.com/store/apps/details?id=live.doctora.app&pcampaignid=web_share" target='_blank' className='flex items-center'>
                        <img
                            alt="PlayStore"
                            src="/assets/images/play-store.png"
                            className="mx-auto h-9 w-auto"
                        />
                    </a>

                </div>
                <header class="text-center mb-8">
                    <h1 class="text-3xl font-bold text-gray-900">Simple pricing that grows with you</h1>
                </header>
                <div className='w-full md:w-10/12 lg:w-2/3'>
                    <div class="grid grid-cols-1  gap-6">
                        <div class="relative p-1 rounded-3xl">
                            <div class="absolute inset-0 rounded-3xl  opacity-30"></div>
                            <div class="relative bg-white border-brand-400 border-t-4 rounded-3xl p-6 shadow-md transform hover:-translate-y-1 transition-transform">
                                <div class="flex items-center justify-between">
                                    <div>
                                        <h3 class="text-lg font-semibold text-gray-900">OPD Recharge</h3>
                                        <p class="mt-1 text-sm text-gray-500">OPD recharge means you can top up and use as many OPD visits as you need, based on your requirement.</p>
                                    </div>
                                </div>

                                <div class="mt-6 flex items-end space-x-3">
                                    <div>
                                        <div class="text-4xl font-extrabold text-gray-900 leading-none">₹2.00 <span className='text-sm font-normal text-gray-500'>/per opd</span></div>
                                        <div class="text-sm text-gray-500">per use | inclusive gst</div>
                                    </div>
                                </div>

                                <ul class="mt-6 space-y-3 text-sm text-gray-600">
                                    <li class="flex items-start"><svg class="flex-none w-5 h-5 mr-3 mt-0.5 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Unlimited opd centers</li>
                                    <li class="flex items-start"><svg class="flex-none w-5 h-5 mr-3 mt-0.5 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Smart notes</li>
                                    <li class="flex items-start"><svg class="flex-none w-5 h-5 mr-3 mt-0.5 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Advanced reporting</li>
                                    <li class="flex items-start"><svg class="flex-none w-5 h-5 mr-3 mt-0.5 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Priority support</li>
                                    <li class="flex items-start"><svg class="flex-none w-5 h-5 mr-3 mt-0.5 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Unlimited Validity</li>
                                </ul>

                                <p class="mt-6 text-xs text-gray-400">You can recharge it after login.</p>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}
